<template>
  <div>
    <b-button @click="select()" class="d-block d-md-none select-button btn" :class="{'selected-btn': selected}">
      <span v-show="selected">Selected</span>
      <span v-show="!selected">Select</span>
    </b-button>
    <div class="product-container">
      <table class="products-table" :class="{'mb-0': original, 'selected': selected}" >
        <tr class="product rma-product" @click="select()">
          <td class="prod-image" :class="{'prod-image-max-height': product.sales_phrase}">
            <img :src="getImageUrl" @error="setAltImg($event)" alt="" />
            <div v-if="product.sales_phrase"  :class="'prod-sales-phrase ' + product.sales_phrase.slug" v-bind:style="{...product.styles}">
              <div>{{product.sales_phrase.text}}</div>
            </div>
          </td>
          <td class="product-info">
            <div class="prod-name">
              <span v-if="showQuantity" class="product-quantity">
                {{product.quantity}}
              </span>
              <span>{{displayName | stripHTML}}</span>
            </div>
            <div class="notranslate prod-price">
              <span v-if="showDiscount" class="prod-original-price">{{exchangeableProductOriginalTotalPrice}}</span>
              <span>{{exchangeableProductTotalPrice}}</span>
              <span v-if="showDiscount" class="prod-discount">{{exchangeableProductDiscount}}% Off</span>
            </div>
            <div class="prod-blurb d-flex flex-column">
              <div v-for="(subtext, index) in product.subtext" v-bind:key="index" class="mt-1">
                <font-awesome-icon class="icon" :icon="['fas', 'check-circle']"></font-awesome-icon>
                <span class="ml-2">{{subtext | stripHTML}}</span>
              </div>
            </div>
          </td>
          <td class="prod-selection">
            <b-button @click="select()" class="d-none d-md-block select-button btn" :class="{'selected-btn': selected}">
              <span v-show="selected">Selected</span>
              <span v-show="!selected">Select Package</span>
            </b-button>
            <div class="prod-selection-check-mark" :class="{ 'selected': selected }">
              <font-awesome-icon v-if="selected" :icon="['fas', 'check-square']"></font-awesome-icon>
              <font-awesome-icon v-else :icon="['far', 'square']"></font-awesome-icon>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {formatCurrency, getItemImageUrl, setFallbackImageUrl} from '../utils'

export default {
  name: 'ExchangeProduct',
  props: {
    product: Object,
    selected: Boolean,
    original: Boolean,
    item: Object
  },
  computed: {
    getImageUrl: function() {
      const item = {campaign_product: this.product.to_campaign_product, variant: this.product.to_variant}
      return getItemImageUrl(item, 'medium')
    },
    showQuantity: function() {
      return false
    },
    variantLabel() {
      let options = []
      let label = ''

      if (this.product.to_variant) {
        this.product.to_variant.options.forEach((option) => {
          options.push(option.name + ': ' + option.value)
        })

        label = options.join(', ')
      }

      return label
    },
    displayName: function() {
      let name = this.product.to_campaign_product.name
      const variantLabel = this.variantLabel

      if (variantLabel) {
        name += ' - ' + variantLabel
      }

      return this.product.display_name ? this.product.display_name : name
    },
    exchangeableProductTotalPrice: function() {
      if (this.original && (this.item.campaign_product.id === this.product.to_campaign_product.id) &&
        (this.item.quantity === this.product.quantity) &&
        (this.item.variant === this.product.to_variant)) {
        return formatCurrency(this.item.current_price, this.item.order.currency)
      }

      return formatCurrency(this.product.price * this.product.quantity,
        this.product.to_campaign_product.currency)
    },
    exchangeableProductOriginalTotalPrice: function() {
      return formatCurrency(+this.product.retail_price * this.product.quantity,
        this.product.to_campaign_product.currency)
    },
    exchangeableProductDiscount: function() {
      return Math.round((100 - (+this.product.price / +this.product.retail_price * 100)))
    },
    showDiscount: function() {
      return +this.product.price < +this.product.retail_price
    }
  },
  methods: {
    setAltImg: function(event) {
      setFallbackImageUrl(event, this.product.to_campaign_product, 'medium')
    },
    select() {
      this.$emit('select', this.product)
    }
  }
}
</script>

<style scoped lang="less">

</style>
